/* eslint-disable @next/next/no-img-element */
import http from "utilities/http";
import { isEmpty } from "lodash";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG } from "framework/store/constants";
import { useEffect, useState } from "react";
import Image from "next/image";
import CouponPro from 'components/chuyen-gia/content/detail/couponPro';
import SeeMore from "components/seeMore";

export default function Index({ profession, vouchers: vouchersProp }) {
    // vouchersProp.data = vouchersProp.data.filter(x => !x.is_expired);
    const [couponSave, setCouponSave] = useState([]);

    const getCouponSaved = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            return;
        }
        const response = await http(`community/me/voucher`, {}, {
            method: "GET",
            token: `Bearer ${getCookie(TOKEN_CONGDONG)}`
        }, 'v2');
        if (response.code == 200) {
            setCouponSave(response.data);
        }
    };

    useEffect(() => {
        getCouponSaved();
    }, []);

    return (
        <>
            {
                isEmpty(vouchersProp.data) &&
                <div className="voucher-none">
                    <div className="thumb"><Image width={80} height={80} src="/images/icon-component-none.png" alt="" /></div>
                    <p className="text">Chuyên gia chưa có mã giảm giá</p>
                </div>
            }
            {
                !isEmpty(vouchersProp.data) &&
                <>
                    <div className="discount">
                        <ul>
                            {vouchersProp.data.map((item, index) => {
                                const isSave = couponSave.some(x => x.id === item.id);
                                return <CouponPro key={index} coupon={item} profession={profession} isSave={isSave} />;
                            })}

                        </ul>
                    </div>
                </>
            }
        </>
    );
}
